export const InputError = {
  paddingTop: '5px',
  paddingLeft: '5px',
  color: '#d32f2f',
  fontSize: '13px',
}
